module.exports = __webpack_public_path__ + "img/flechaVerde.1f1b6e41.svg";